import { render, staticRenderFns } from "./CompanyLeaveRightForm.vue?vue&type=template&id=28a31416"
import script from "./CompanyLeaveRightForm.vue?vue&type=script&lang=js"
export * from "./CompanyLeaveRightForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports